<div class="date-week-component">
  <div class="base-input-container">
    <astral-input [control]="selectedWeeksControl" [readonly]="isReadonly"></astral-input>
  </div>
  <div class="date-week-dropdown">
    <div class="pattern">
      <table>
        <tbody>
          <tr>
            <td>{{ 'ROUND_PLANNING_CHECKLIST_FORM.START_WEEK' | translate }}</td>
            <td>
              <app-select-freeform
                [itemsSource]="customWeekIntervalStart"
                (valueChange)="onSelectStartInterval($event)"
                [multiple]="false"
                [initialValues]="startWeek"
                [isReadonly]="isReadonly"
              ></app-select-freeform>
            </td>
          </tr>
          <tr>
            <td>{{ 'ROUND_PLANNING_CHECKLIST_FORM.REPEAT_EVERY' | translate }}</td>
            <td>
              <app-select-freeform
                [itemsSource]="customWeekIntervals"
                (valueChange)="onSelectCustomInterval($event)"
                [multiple]="false"
                [initialValues]="customSelectWeekInterval"
                [isReadonly]="isReadonly"
              ></app-select-freeform>
            </td>
            <td>{{ 'ROUND_PLANNING_CHECKLIST_FORM.REPEAT_EVERY_END' | translate }}</td>
          </tr>
          <tr>
            <td>{{ 'ROUND_PLANNING_CHECKLIST_FORM.END_WEEK' | translate }}</td>
            <td>
              <app-select-freeform
                [itemsSource]="customWeekIntervalEnd"
                (valueChange)="onSelectEndInterval($event)"
                [multiple]="false"
                [initialValues]="endWeek"
                [isReadonly]="isReadonly"
              ></app-select-freeform>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="date-week-dropdown__apply">
      <astral-button
        variant="secondary"
        size="extra-small"
        type="button"
        labelKey="ROUND_PLANNING_CHECKLIST_FORM.SELECT_BTN"
        [disabled]="isReadonly"
        (click)="checkWeeksCustom()"
      ></astral-button>
    </div>

    <div class="year-control-buttons">
      <div>
        @if (showPreviousYear) {
          <span class="year-control" (click)="changeYear(false)"> << </span>
        }
        <span
          ><b>{{ year }}</b></span
          >
          @if (showNextYear) {
            <span class="year-control" (click)="changeYear(true)"> >> </span>
          }
        </div>
      </div>
      <div class="date-week-items">
        @for (week of weeks; track week) {
          <div class="week-item" [class.active]="weekItemActive(week.weekNumber)" (click)="selectWeekNumberClick(week.weekNumber)">
            <div class="week-item-number">{{ week.weekNumber }}</div>
            <div class="week-item-dates">
              <div>
                {{ week.startDateString }}
              </div>
              <div>
                {{ week.endDateString }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
